import React, { useContext, useEffect, useState } from "react";
import { useObservable } from "micro-observables";
import { DialogContext, ModalId } from "@ui/components/dialog/dialog-provider";
import { getStartedManager } from "@core/service-container";
import { useLocation } from "react-router";
import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";

export const GetStartedCompletedHandler: React.FC = () => {
	const location = useLocation();
	const dialogContext = useContext(DialogContext);
	const [shouldTrackEvent, setShouldTrackEvent] = useState(true);
	const shouldDisplayGetStartedCompletedDialog = useObservable(
		getStartedManager.shouldDisplayGetStartedCompletedDialog,
	);

	useEffect(() => {
		if (!shouldDisplayGetStartedCompletedDialog) return;

		if (shouldTrackEvent) {
			analyticsService.trackEvent({
				category: AnalyticsCategory.GETSTARTED,
				action: "allStepsCompletedPage",
			});
			setShouldTrackEvent(false);
		}

		dialogContext?.openModal(ModalId.GetStartedCompleted, {
			onClose: closeModal => {
				getStartedManager.shouldDisplayGetStartedCompletedDialog.set(false);
				closeModal();
			},
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, shouldDisplayGetStartedCompletedDialog]);

	return null;
};
